import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";

export default function DeletionDialog({visible, setVisible, deleteCallback, type, name}) {
    return (
        <Dialog
            visible={visible}
            onHide={() => setVisible(false)}
            header="Confirm Deletion"
        >
            <p className="mb-3">
                This will delete the {type} {name}. Do you want to proceed?
            </p>
            <Button onClick={() => setVisible(false)} label="Cancel" className='mr-4'/>
            <Button onClick={deleteCallback} label="Delete" severity="danger"/>
        </Dialog>
    )
}
